module.exports = __webpack_public_path__ + "static/img/products_BioOmics.300b423b.png";